/** localStorage key: optional signup coupon code to redeem after first authenticated session */
export const PENDING_SIGNUP_COUPON_KEY = "ds_pending_signup_coupon";
